<template>
    <!-- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): карточка узла схемы — одна разметка для вкладки ERD
         (AttrSchemeGraphErd, перенесена оттуда без изменений вида) и вида узлов «Картки» графа схемы (AttrSchemeGraphV2). Координаты — внутри карточки (0, 0 — левый верхний угол), место — translate(x, y).
         Карточка c — utils/schemeGraphErd.js (sgeCardOf / sgeCardText): заголовок, вид узла, пилюли горизонтов (rx), строки полей (глиф роли, тег dim_role). interactive — клики заголовка / строк
         и наведение (ERD); без него карточка «немая» — указатель ловит узел графа (тяга, выбор, двойной клик). Компонент без widget_id (callgraph-mixin не трогает store).
         Цвет текста — style (не атрибут fill): внутри узла графа правило .sg2-node text перекрыло бы атрибут; кегли — селекторы с .sge-card (специфичнее .sg2-node text) -->
    <g class="sge-card" :transform="'translate(' + x + ',' + y + ')'" :class="{ 'sge-fill': c.fill, 'sge-off': !c.use, 'sge-hl': hl, 'sge-dim': dim, 'sge-mute': !interactive }">
        <rect class="sge-body" x="0" y="0" :width="c.w" :height="c.h" rx="7" :fill="c.fill ? c.color : '#FFFFFF'" :stroke="c.color" />
        <line x1="0" :y1="S.headH" :x2="c.w" :y2="S.headH" :stroke="c.fill ? 'rgba(246,245,240,0.28)' : c.color" :stroke-width="c.fill ? 1 : 1.5" />
        <g class="sge-card-head" @click="headClick" @mouseenter="enter('card', c, $event)" @mousemove="move" @mouseleave="leave">
            <rect x="0" y="0" :width="c.w" :height="S.headH" fill="transparent" />
            <text class="sge-ctitle" x="12" y="23" :style="{ fill: c.titleInk }">{{ c.titleText }}</text>
            <text class="sge-ckind" :x="c.w - 10" y="22" text-anchor="end" :style="{ fill: c.muted }">{{ c.kind }}</text>
            <g v-for="p in c.pillsAt" :key="'p' + p.name" class="sge-pill">
                <rect :x="p.rx" y="34" :width="p.w" height="17" rx="8.5" :fill="pillFill(c, p)" :stroke="pillStroke(c, p)" stroke-width="1.2" :stroke-dasharray="p.solid ? null : '3 2'" />
                <text :x="p.rx + p.w / 2" y="46.5" text-anchor="middle" :style="{ fill: pillText(c, p) }">{{ p.short }}</text>
            </g>
        </g>
        <g v-for="(r, i) in c.rows" :key="'r' + r.index" class="sge-row" :class="{ 'sge-hl': !!hlRows && hlRows.has(c.id + '|' + r.field), 'sge-off': !r.use }"
            @click="rowClick(r, $event)" @mouseenter="enter('row', { c, r }, $event)" @mousemove="move" @mouseleave="leave">
            <rect class="sge-row-bg" x="3" :y="rowY(i)" :width="c.w - 6" :height="S.rowH" rx="4" />
            <line v-if="i > 0" x1="10" :y1="rowY(i)" :x2="c.w - 10" :y2="rowY(i)" :stroke="c.fill ? 'rgba(246,245,240,0.28)' : '#E3E8EC'" stroke-width="1" />
            <text class="sge-glyph" x="20" :y="rowY(i) + S.rowH / 2 + 4.5" text-anchor="middle" :style="{ fill: c.muted }">{{ r.glyph }}</text>
            <text class="sge-frow" :class="{ 'sge-key': r.key }" x="34" :y="rowY(i) + S.rowH / 2 + 4.5" :style="{ fill: c.ink }">{{ r.text }}</text>
            <rect v-if="r.tag" :x="c.w - 10 - r.tw" :y="rowY(i) + S.rowH / 2 - 8" :width="r.tw" height="16" rx="4" :fill="c.fill ? 'rgba(246,245,240,0.18)' : (r.key ? '#E8EEF3' : '#F1F3F4')" />
            <text v-if="r.tag" class="sge-tag" :x="c.w - 10 - r.tw / 2" :y="rowY(i) + S.rowH / 2 + 3.5" text-anchor="middle" :style="{ fill: c.muted }">{{ r.tag }}</text>
        </g>
        <rect v-if="hl" class="sge-ring" x="-3" y="-3" :width="c.w + 6" :height="c.h + 6" rx="9" />
    </g>
</template>

<script>
// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): см. шаблон; стили карточки — ниже (перенесены из AttrSchemeGraphErd.vue)
import { SGE, sgePillFill, sgePillStroke, sgePillText } from '@/utils/schemeGraphErd'

export default {
    name: 'SchemeErdCard',
    props: {
        c: { type: Object, required: true },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        hl: { type: Boolean, default: false },
        hlRows: { type: Object, default: null },   // Set 'узел|поле' — подсвеченные строки
        dim: { type: Boolean, default: false },
        interactive: { type: Boolean, default: false },
    },
    emits: ['pick-head', 'pick-row', 'hover', 'move', 'leave'],
    setup() { return { S: SGE } },
    methods: {
        rowY(i) { return SGE.headH + SGE.rowPadT + i * SGE.rowH },
        pillFill: sgePillFill,
        pillStroke: sgePillStroke,
        pillText: sgePillText,
        headClick(ev) { if (!this.interactive) return; ev.stopPropagation(); this.$emit('pick-head', this.c) },
        rowClick(r, ev) { if (!this.interactive) return; ev.stopPropagation(); this.$emit('pick-row', this.c, r) },
        enter(type, item, ev) { if (this.interactive) this.$emit('hover', type, item, ev) },
        move(ev) { if (this.interactive) this.$emit('move', ev) },
        leave() { if (this.interactive) this.$emit('leave') },
    },
}
</script>

<style>
/* IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): стили карточки — из AttrSchemeGraphErd.vue (вид не менялся) */
.sge-card .sge-body { stroke-width: 2; }
.sge-card.sge-off { opacity: .5; }
.sge-card.sge-dim { opacity: .45; }
.sge-card-head { cursor: pointer; }
.sge-card text.sge-ctitle { font-size: 15px; font-weight: 600; }
.sge-card text.sge-ckind { font-size: 10px; font-weight: 500; letter-spacing: 0.8px; text-transform: uppercase; }
.sge-card .sge-pill text { font-size: 11px; font-weight: 600; }
.sge-row { cursor: pointer; }
.sge-row .sge-row-bg { fill: transparent; }
.sge-row:hover .sge-row-bg { fill: rgba(96, 125, 139, 0.08); }
.sge-row.sge-hl .sge-row-bg { fill: rgba(245, 158, 11, 0.22); stroke: var(--sge-hl, #f59e0b); stroke-width: 1.2; }
.sge-fill .sge-row.sge-hl .sge-row-bg { fill: rgba(255, 255, 255, 0.22); }
.sge-row.sge-off { opacity: .45; }
.sge-card text.sge-frow { font-size: 13px; font-weight: 400; }
.sge-card text.sge-frow.sge-key { font-weight: 700; }
.sge-card text.sge-glyph { font-size: 12px; font-weight: 600; }
.sge-card text.sge-tag { font-size: 10px; font-weight: 500; letter-spacing: 0.2px; }
.sge-ring { fill: none; stroke: var(--sge-hl, #f59e0b); stroke-width: 2.5; pointer-events: none; }
/* «немая» карточка (вид узлов графа): курсор и наведение — узла графа */
.sge-card.sge-mute .sge-card-head, .sge-card.sge-mute .sge-row { cursor: inherit; }
.sge-card.sge-mute .sge-row:hover .sge-row-bg { fill: transparent; }
</style>
